import TogglerController from '../../shared/toggler_controller'

// sub-class to get around a toggler nested inside another toggler
export default class extends TogglerController {
}